import _makeSpacesStore from './data/spaces/store';
export { _makeSpacesStore as makeSpacesStore };
import _ceMakeTypesStore from './data/types/store';
export { _ceMakeTypesStore as ceMakeTypesStore };
import _UpdatingStore from './data/UpdatingStore';
export { _UpdatingStore as UpdatingStore };
import _makeEditingStore from './data/editing/store';
export { _makeEditingStore as makeEditingStore };


export * from './data';